import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function disable2FactorAuthentication(code) {
  return dispatchCommand("Disable2FactorAuthentication", {
    code: code
  });
}
